// @charset "utf-8";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import vueGlobalConfig from '@/lib/vueGlobalConfig'
import EasyScroll from 'easyscroll'
import feedBack from '@/lib/feedback'
import qrCode from '@/lib/qrcode'

Vue.use(EasyScroll)
Vue.use(feedBack)
Vue.use(qrCode)

new Vue({
    el: '#app',
    router,
    store,
    template: '<App></App>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js